module.exports = __webpack_public_path__ + "img/icon_map_6.bb94de03.png";